import { BubbleAlignment, BubbleShape } from "./Banner-Types";
const LeftParallelogramSkew = 20;
const LeftParallelogramAddOn = {
    left: "0%",
    height: "25%",
    width: "150%",
    transform: "translate(-33%, -59%) rotate(4deg)",
};
const RightParallelogramSkew = -20;
const RightParallelogramAddOn = {
    height: "25%",
    width: "150%",
    top: "100%",
    transform: "translate(-60%, -35%) rotate(-4deg)",
};
/**
 * Align shape appropriately inside banner image
 * @param align
 * @param fitAll
 * @param buffer
 * @returns
 */
export const alignStyling = (align, shape, fitAll = false, buffer = 0) => {
    let blockStyle = {};
    //Setting skew/rotation on the shape causes the text to also be skewed/rotated which we don't want.
    //We have to set the skew/rotation opposite to the shape's to correct this.
    let skewCorrection = "0deg";
    let rotationCorrection = "0deg";
    if (shape === BubbleShape.LeftParallelogram && fitAll) {
        skewCorrection = "-20deg";
    }
    if (shape === BubbleShape.RightParallelogram && fitAll) {
        skewCorrection = "20deg";
    }
    if (shape === BubbleShape.InvertedTrapezoid && fitAll) {
        rotationCorrection = "20deg";
    }
    if (shape === BubbleShape.ScaleneTrapezoid && fitAll) {
        rotationCorrection = "-20deg";
    }
    switch (align) {
        case BubbleAlignment.Left:
            blockStyle = {
                left: !!buffer ? buffer + "%" : "0%",
                transform: fitAll ? `translate(75%, -50%) skew(${skewCorrection}) rotateX(${rotationCorrection})` : "",
            };
            break;
        case BubbleAlignment.Center:
            blockStyle = {
                left: "50%",
                transform: fitAll ? `translate(-50%, -50%) skew(${skewCorrection}) rotateX(${rotationCorrection})` : "",
            };
            break;
        case BubbleAlignment.Right:
            blockStyle = {
                left: !!buffer ? `${100 - buffer}%` : "100%",
                transform: fitAll ? `translate(10%, -50%) skew(${skewCorrection}) rotateX(${rotationCorrection})` : "",
            };
            break;
    }
    return blockStyle;
};
/**
 * Set styling to get desired shape
 * @param shape
 * @param isMobile
 * @returns
 */
export const shapeStyling = (shape, isMobile) => {
    let addOn = {};
    switch (shape) {
        case BubbleShape.Circle:
            addOn = {
                borderRadius: "50%",
                aspectRatio: isMobile ? "2.5 / 1" : "1/1",
            };
            break;
        case BubbleShape.Square:
            if (isMobile)
                addOn = { transform: "translate(-50%, -10px)" };
            break;
        case BubbleShape.RightParallelogram:
            if (isMobile) {
                addOn = RightParallelogramAddOn;
            }
            else {
                addOn = {
                    transform: `translate(-50%, -50%) skewX(${RightParallelogramSkew}deg)`,
                };
            }
            break;
        case BubbleShape.LeftParallelogram:
            if (isMobile) {
                addOn = LeftParallelogramAddOn;
            }
            else {
                addOn = {
                    transform: `translate(-50%, -50%) skewX(${LeftParallelogramSkew}deg)`,
                };
            }
            break;
        case BubbleShape.InvertedTrapezoid:
            if (isMobile) {
                addOn = RightParallelogramAddOn;
            }
            else {
                addOn = {
                    transform: "translate(-50%, -50%) perspective(500px) rotateX(-20deg)",
                };
            }
            break;
        case BubbleShape.ScaleneTrapezoid:
            if (isMobile) {
                addOn = LeftParallelogramAddOn;
            }
            else {
                addOn = {
                    transform: "translate(-50%, -50%) perspective(500px) rotateX(20deg)",
                };
            }
            break;
    }
    let shapeStyle = {};
    if (isMobile) {
        shapeStyle = Object.assign({ transform: "translate(-50%, -15%)", aspectRatio: "1/1", top: "100%", width: "150%", backgroundColor: "white", position: "absolute", left: "50%" }, addOn);
    }
    else {
        shapeStyle = Object.assign({ transform: "translate(-50%, -50%)", aspectRatio: "1/1", top: "50%", height: "150%", backgroundColor: "white", position: "absolute" }, addOn);
    }
    return shapeStyle;
};
